<template>
  <main role="main" id="main_lesson">
		<div class="pre-pare__add__head display-flex-center justify-content-between">
			<router-link to="/danh-sach-giao-an" class="secondary-color-txt font-size-16 pre-pare__add__close">
				<i class="icon-close font-size-12 secondary-color-txt"></i> <span class="only-pc">Thoát</span>
			</router-link>
			<h1 class="pre-pare__add__title margin-0 p-0 book-viewer__title font-size-16 secondary-color-txt font-sanpro-semibold">Tạo bài giảng mới</h1>
			<span @click="toggleSidebarMenu()"><i class="icon-category font-size-20 d-md-block d-lg-none"></i></span>
		</div>
		<div class="pre-pare__add__body display-flex justify-content-between position-rel">
			<div class="pre-pare__add__sidebar" :class="{'active': activeSidebarMobile}">
				<div class="book-viewer__cats__wrap">
					<h2 class="book-viewer__cats__title primary-color-txt font-size-24 font-sanpro-semibold">
						Bộ lọc
					</h2>
					<div class="pre-pare__add__sidebar__action display-flex-center justify-content-between">
						<a
							href="javascript:;"
							class="btn btn-main border-rd-20 font-size-16 display-flex-center justify-content-center"
							@click="$bvModal.show('popup-up-new')"
						>
							<i class="icon-plus color-light"></i> Mới
						</a>
            <!-- <a
							href="javascript:;" class="btn btn-main border-rd-20 font-size-16 display-flex-center justify-content-center"
							:class="{ 'not-active': classId == 0 || subjectId == 0 }"
							@click="openModalUpload()"
						>
							<i class="icon-upload color-light"></i> Tải lên
						</a > -->
					</div>
				</div>
				<vue-custom-scrollbar
					id="book_viewer__cats"
					class="scroll-area pre-pare__add__cats"
					:settings="settingsViewBookSidebar"
				>
					<div class="book-viewer__cats__wrap">
						<b-card no-body v-for="(item, index) in classes" class="card-item border-0 secondary-color-txt bg-transparent" :key="index"  :class="{'active':true}">
							<div class="card-wrap display-block">
									<b-card-header 
										header-tag="header"
										role="tab"
										class="border-0 border-rd-8 display-flex-center primary-color-txt font-size-16 p-0 border-rd-0 bg-transparent cursor-pointer"
										@click="filterByClass(item.classId, item)"
										:class="{'active font-sanpro-semibold': classId === item.classId}"
									>
										<div class="cat-head display-flex justify-content-md-between full-width">
											<span class="margin-0 font-size-16">
												{{ item.className }}
											</span>
										</div>
									</b-card-header>
									<b-collapse :id="`${item.classId}`" :visible="item.classId === classId" accordion="my-accordion" role="tabpanel">
										<b-card-body class="p-0">
											<ul class="cat-child margin-0" >
												<li class="d-block" v-for="(child, pos) of item.subjects" :class="{'active': subjectId === child.subjectId}" :key="pos">
													<a 
														href="javascript:;" 
														class="font-sanpro primary-color-txt font-size-16 display-flex justify-content-between full-width"  
														@click="filterBySubject(child, pos)"
													>
														<span>{{ child.subjectName }}</span>
													</a>
												</li>
											</ul>
										</b-card-body>
									</b-collapse>
							</div>
					</b-card>
					</div>
				</vue-custom-scrollbar>
			</div>
			<div class="pre-pare__add__main">
				<h2 class="book-viewer__cats__title pre-pare__add__main__title primary-color-txt font-size-24 font-sanpro-semibold">
					Bài giảng mẫu
				</h2>
        <vue-custom-scrollbar
          class="scroll-area pre-pare__add__cats pre-pare__add__list"
          :settings="settingsViewBookSidebar"
        >
          <div class="row">
  					<div v-for="(item, index) of lessons" :key="index" class="item col-lg-4 col-sm-6">
  						<div class="item__wrap">
                <router-link
                  :to="{ name: 'prepareLessonEdit', params: {classId: item.classId, subjectId: item.subjectId, id: 0}, query: { sample: item.bookLessonPlanId }}"
                  class="display-block item__head aspect-ratio aspect-ratio--16-9 text-center border-rd-4 bg-transparent"
                >
                  <div class="item__img">
                    <img :src="`${urlPlatformCmsImg}/${item.imageUrl}`" :alt="item.title">
                  </div>
                </router-link>
  							<div class="item__body">
  								<h3 class="primary-color-txt margin-0 font-size-16 primary-color-txt font-sanpro-semibold">
  									<router-link
  										:to="{ name: 'prepareLessonEdit', params: {classId: item.classId, subjectId: item.subjectId, id: 0}, query: { sample: item.bookLessonPlanId }}"
  										class="primary-color-txt"
  									>
  										{{ item.title }}
  									</router-link>
  								</h3>
  							</div>
  						</div>
  					</div>
          </div>
          <div id="lesson__end"></div>
				</vue-custom-scrollbar>
			</div>
      <div v-if="activeSidebarMobile" class="pre-pare__add__sidebar__overlay full-width" @click="toggleSidebarMenu()"></div>
		</div>

		<b-modal id="popup-up-new" class="modal-info" hide-footer size="lg" scrollable centered>
			<template v-slot:modal-header>
				<div class="modal-info__head modal-info__head--psmall display-flex-center justify-content-between full-width">
					<h4 class="modal-info__title font-sanpro-bold primary-color-txt">Thông tin</h4>
					<span @click="$bvModal.hide('popup-up-new')" class="modal-info__close"><i class="icon-close"></i></span>
				</div>
			</template>
			<div class="modal-info__body primary-color-txt font-sanpro-light bg-color-light">
				<div class="pre-pare__add__modal">
					<form class="needs-validation creat-dt" novalidate>
						<div class="form-group" :class="{ 'is-invalid': submitted && $v.addObj.title.$error }">
							<input
								type="text"
								v-model="addObj.title"
								class="form-bg-gray-light form-30h border-rd-20 full-width"
								id="tieude"
								placeholder="Tên bài giảng *"
							/>
              <p v-if="submitted && $v.addObj.title.$error" class="form-err-noti four-color font-size-15">Bạn hãy nhập tên bài bài giảng</p>
						</div>
						<div class="row">
							<div class="col-md-6">
								<div class="form-item" :class="{ 'is-invalid': submitted && !$v.addObj.classId.isSelected }">
									<select v-model="addObj.classId" id="inputState_1" class="form-bg-gray-light form-30h border-rd-20 full-width">
										<option value="0">Lớp - Tất cả</option>
										<option v-for="item of classes" :key="item.classId + '-class'" :value="item.classId">
											{{ item.className }}
										</option>
									</select>
                  <p v-if="submitted && !$v.addObj.classId.isSelected" class="form-err-noti four-color font-size-15">Bạn hãy chọn lớp</p>
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-item" :class="{ 'is-invalid': submitted && !$v.addObj.subjectId.isSelected }">
									<select v-model="addObj.subjectId" id="inputState_2" class="form-bg-gray-light form-30h border-rd-20 full-width">
										<option value="0">Môn - Tất cả</option>
										<option v-for="item of subjects" :key="item.subjectId + '-subject'" :value="item.subjectId">
											{{ item.subjectName }}
										</option>
									</select>
                  <p v-if="submitted && !$v.addObj.subjectId.isSelected" class="form-err-noti four-color font-size-15">Bạn hãy chọn môn</p>
								</div>
							</div>
						</div>
						<div class="form-action display-flex-center justify-content-end">
							<a
                href="javascript:;"
                class="font-size-16 primary-color font-weight-semi-bold"
                @click="$bvModal.hide('popup-up-new')"
              >
                Hủy
              </a>
							<button
                @click="redriectAddPage()"
                type="button"
                class="btn btn-main font-size-16 border-rd-20 display-flex-center justify-content-center"
              >
								Hoàn thành
							</button>
						</div>
					</form>
				</div>
			</div>
		</b-modal>

		<b-modal id="popup-up" class="modal-info" hide-footer size="lg" scrollable centered>
			<template v-slot:modal-header>
				<div class="modal-info__head modal-info__head--psmall display-flex-center justify-content-between full-width">
					<h4 class="modal-info__title font-sanpro-bold primary-color-txt">Tải lên</h4>
					<span @click="$bvModal.hide('popup-up')" class="modal-info__close"><i class="icon-close"></i></span>
				</div>
			</template>
			<div class="modal-info__body modal-info__body__upload primary-color-txt font-sanpro-light bg-color-light">
        <b-tabs>
          <b-tab title="Tải lên">
            <div class="pre-pare__add__modal__upload">
              <div class="pre-pare__add__modal__upload__wrap position-rel border-rd-4 form-file-hide">
                <i class="icon-upload font-size-46"></i>
                <p class="pre-pare__add__modal__upload__desc display-block secodnary-color-txt margin-0 text-center">
                  Bấm vào đây để tải lên
                  bài giảng PowerPoint (pptx.)
                </p>
                <input type="file" id="file_pptx" ref="file_pptx" accept=".pptx" @change="upload()" />
              </div>
            </div>
          </b-tab>
          <b-tab title="Bài giảng của tôi">
              <div class="pre-pare__add__modal__mylesson__filter display-flex-center">
                <div class="form-item form-item--class">
                  <select class="form-bg-gray-light form-30h border-rd-20 full-width font-size-15" @change="filterMyLessonByClass">
                    <option value="0">Lớp - Tất cả</option>
                    <option v-for="item of classes" :key="item.classId + '-class'" :value="item.classId">
                      {{ item.className }}
                    </option>
                  </select>
                </div>
                <div class="form-item form-item--subject">
                  <select class="form-bg-gray-light form-30h border-rd-20 full-width font-size-15" @change="filterMyLessonBySubject">
                    <option value="0">Môn - Tất cả</option>
                    <option v-for="item of subjectsMylessons" :key="item.subjectId + '-subject'" :value="item.subjectId">
                      {{ item.subjectName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="pre-pare__add__modal__mylesson__list display-block full-width">
                <div class="row">
                  <div v-for="(item, index) of lessonsUploaded" :key="index" class="item col-md-4 col-sm-6">
                    <div class="item__wrap">
                      <div class="item__head aspect-ratio aspect-ratio--16-9 text-center border-rd-4">
                        <a href="javascript:;" @click="redriectDetail(item)" class="display-block">
                          <img :src="item.imageUrl" :alt="item.title" />
                        </a>
                      </div>
                      <div class="item__body">
                        <h3 class="primary-color-txt margin-0 font-size-16 primary-color-txt font-sanpro-semibold">
                          <a href="javascript:;" @click="redriectDetail(item)" class="primary-color-txt display-block">
                            {{ item.title }}
                          </a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </b-tab>
        </b-tabs>
			</div>
		</b-modal>
  </main>
  <!--End Body-->
</template>


<script lang="ts">
import { mapActions } from "vuex"
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { required } from "vuelidate/lib/validators"
import classService from "./../_api/classService"
import fileService from "./../_api/fileService"
import lessonService from "./../_api/lessonService"
import { APP_CONFIG } from '@/utils/constants'

export default {
	name: "PrepareDocAdd",
	components: {
		vueCustomScrollbar
	},
  data () {
    return {
      userId: 1,
      loadMore: true,
      submitted: false,
      classId: 0,
      subjectId: 0,
      keyword: "",
      pageIndex: 1,
      pageSize: 9,
      lessons: [],
      lessonsUploaded: [],
      classes: [],
      subjects: [],
      addObj: { title: "", classId: 0, subjectId: 0 },
      lessonTypeTemplate: 3,
      lessonTypeUpload: 2,
      fileChunk: [],
			totalFileChunk: 0,
			settingsViewBookSidebar: {
				maxScrollbarLength: 300
			},
      paramFilterMyLesson: {classId: 0, subjectId: 0},
      paramFilterSampleLesson: {classId: 0, subjectId: 0, keyword: '', pageIndex: 1, pageSize: 12},
      subjectsMylessons: [],
      activeSidebarMobile: false,
      urlPlatformCmsImg: APP_CONFIG.urlPlatformCmsImg,
      elmEndItem: null,
      observer: null,
      pagingData: {}
    };
	},
	validations: {
    addObj: {
      title: { required },
      classId: {
        required,
        isSelected(value) {
					return value > 0 ? true : false
        }
      },
      subjectId: {
        required,
        isSelected(value) {
					return value > 0 ? true : false
        }
      },
    },
	},
  watch: {
    fileChunk(n, o) {
      if (n.length > 0) {
        var partCount = this.totalFileChunk - n.length + 1;
        var filePartName =
          this.file.name + ".part_" + partCount + "." + this.totalFileChunk;
        this.uploadChunk(this.fileChunk[0], filePartName);
      }
    },
    "addObj.classId": function (val) {
      this.addObj.subjectId = 0;
      this.subjects = this.addObj.classId > 0 ? this.getSubjects(this.addObj.classId) : [];
    },
    keyword: function (val) {
      this.lessonsUploaded = [];
      this.getLessonsUploaded();
    },
  },
	created() {
    this.getClasses();
    // this.fetchSampleLesssons()
    // this.getLessons();
    // this.getLessonsUploaded();
  },
  mounted() {
    this.mountedScroll()
  },
  beforeDestroy () {
    this.observer && this.observer.unobserve(this.elmEndItem);
  },
  methods: {
    ...mapActions("common", ["setLoading"]),

    mountedScroll () {
      this.elmEndItem = document.getElementById('lesson__end')
      if (this.elmEndItem && !this.observe) {
        this.observer = new IntersectionObserver(this.handleScrollEnd, {threshold: 1})
        this.observer.observe(this.elmEndItem)
      }
    },

    // getAll() {
    //   this.classId = 0;
    //   this.subjectId = 0;
    //   this.addObj.ClassId = 0;
    //   this.addObj.SubjectId = 0;
    //   this.fetchSampleLesssons();
    // },

    filterByClass(id) {
      this.classId = id;
      this.subjectId = 0;
      this.addObj.classId = id;
      this.addObj.subjectId = 0;
      this.paramFilterSampleLesson = {...this.paramFilterSampleLesson, subjectId: 0, classId: id, pageIndex: 1}
      // this.pageIndex = 1;
      this.fetchSampleLesssons();
      this.activeSidebarMobile = false;
    },

    filterBySubject(subject) {
      this.subjectId = subject.subjectId;
      this.addObj.subjectId = subject.subjectId;
      this.paramFilterSampleLesson = {...this.paramFilterSampleLesson, subjectId: subject.subjectId, pageIndex: 1}
      // this.pageIndex = 1;
      this.fetchSampleLesssons();
      this.activeSidebarMobile = false;
    },

    fetchSampleLesssons () {
      let self = this
      lessonService.getLessonsSample(self.paramFilterSampleLesson).then(res => {
        // let data = res ? res.list[0].listBookLessonPlans : []
        // let data = res ? res.list : []
        self.pagingData = res ? res.paging : {}
        if (res && self.paramFilterSampleLesson.pageIndex === 1) {
          self.lessons = res.list
        } else if (res && self.paramFilterSampleLesson.pageIndex !== 1) {
          self.lessons = [...self.lessons, ...res.list]
        } else if (!res) {
          self.lessons = []
        }
      })
    },

    handleScrollEnd () {
      if (this.paramFilterSampleLesson.pageIndex < this.pagingData.totalPage) {
        this.paramFilterSampleLesson = {...this.paramFilterSampleLesson, pageIndex: this.paramFilterSampleLesson.pageIndex + 1}
        this.fetchSampleLesssons();
      }
    },

    redriectAddPage() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
			}
			this.$bvModal.hide('popup-up-new')
      this.$router.push( "/sua-giao-an/" + this.addObj.classId + "/" + this.addObj.subjectId + "/0/" + this.addObj.title );
    },

    upload() {
      let self = this;
      self.setLoading(true);
      this.file = this.$refs.file_pptx.files[0];
      if ( this.file.type == "application/vnd.openxmlformats-officedocument.presentationml.presentation" ) {
        var maxFileSizeMB = 10;
        var bufferChunkSize = maxFileSizeMB * (1024 * 1024);
        var fileStreamPos = 0;
        var endPos = bufferChunkSize;
        var size = this.file.size;
        while (fileStreamPos < size) {
          this.fileChunk.push(this.file.slice(fileStreamPos, endPos));
          fileStreamPos = endPos;
          endPos = fileStreamPos + bufferChunkSize;
        }
        this.totalFileChunk = this.fileChunk.length;
      } else {
        self.setLoading(false);
      }
    },

    uploadChunk(chunk, fileName) {
      let formData = new FormData();
      formData.append("file", chunk, fileName);
      fileService
        .upload(formData)
        .then((response) => {
          if (response.data.status == "success") {
            this.fileChunk.shift();
            if (
              this.fileChunk.length == 0 &&
              response.data.data !== null &&
              response.data.data !== ""
            ) {
              this.createFromUpload(
                response.data.data,
                this.file.name.replace(".pptx", "")
              );
            }
          }
        })
        .finally();
    },

    createFromUpload(filePath, fileName) {
      let self = this;
      let data = {
        filePath: filePath,
        fileName: fileName,
        classId: this.classId,
        subjectId: this.subjectId,
      };
      lessonService
        .upload(data)
        .then((response) => {
          if (response.data.status == "success") {
						this.$bvModal.hide('popup-up')
            this.$router.push("/danh-sach-giao-an");
          }
        })
        .finally(() => {
          self.setLoading(false);
        });
    },

    redriectDetail(item) {
			// $("#popup-up").modal("hide");
			this.$bvModal.hide('popup-up')
      this.$router.push( "/sua-giao-an/" + item.ClassId + "/" + item.SubjectId + "/" + item.Id );
    },

    getClasses() {
      let self = this;
      self.setLoading(true);

      classService
        .get()
        .then(res => {
					if (res && res.length > 0) {
						this.classId = res[0].Id
            this.paramFilterSampleLesson.classId = res[0].Id
						this.addObj.classId = res[0].Id
						this.classes = res ? res : []
						this.fetchSampleLesssons()
					}
        })
        .finally(() => {
          self.setLoading(false);
        });
    },

    getSubjects(id) {
      if (id == 0) {
        return []
      }
      let indexClassActive = this.classes.findIndex(cl => cl.classId === id)
      return indexClassActive > -1 ? this.classes[indexClassActive].subjects : []
    },

    getLessonsUploaded() {
      lessonService
        .filter(1, 20, this.paramFilterMyLesson.classId, this.paramFilterMyLesson.subjectId, '', this.lessonTypeUpload)
        .then((response) => {
          this.lessonsUploaded = response.data.data.Items;
        })
        .finally();
    },

    getLessons() {
      let self = this;
      self.setLoading(true);
      lessonService
        .filter(
          this.pageIndex,
          this.pageSize,
          this.classId,
          this.subjectId,
          "",
          this.lessonTypeTemplate
        )
        .then((response) => {
          if (this.pageIndex === 1) {
            this.lessons = response.data.data.listModels;
          } else {
            this.lessons = this.lessons.concat(response.data.data.listModels);
          }

          if (this.lessons.length >= response.data.data.total) {
            this.loadMore = false;
          }
        })
        .finally(() => {
          self.setLoading(false);
        });
    },

    openModalUpload () {
      this.getLessonsUploaded()
      this.$bvModal.show('popup-up')
    },

    filterMyLessonByClass (evt) {
      let value = parseInt(evt.target.value)
      this.paramFilterMyLesson.classId = value
      if (value === 0) {
        this.paramFilterMyLesson.subjectId = 0
      }
      this.subjectsMylessons = value === 0 ? [] : this.getSubjects(value)
      this.getLessonsUploaded()
    },

    filterMyLessonBySubject (evt) {
      let value = parseInt(evt.target.value)
      this.paramFilterMyLesson.subjectId = value
      this.getLessonsUploaded()
    },

    toggleSidebarMenu () {
      this.activeSidebarMobile = !this.activeSidebarMobile
    }
  },
};
</script>

<style lang="scss" scoped>
	.pre-pare__add {
		&__head {
			height: 50px;
			padding: 0 35px;
			border-bottom: 1px solid $color_border_line;
		}

		&__close {
			i {
				margin-right: 10px;
			}
		}

		&__body {
			height: calc(100vh - 50px);
		}

		&__sidebar {
			width: 25%;
			background: $color_bg_gray_light;
      @extend .effect-transition-fast;
      border-right: 1px solid $color_border_line;

			.book-viewer__cats__title {
				border-bottom: 2px solid $color_border_line;
			}

			&__action {
				padding: 15px 0;

				a {
					width: 48%;

					i {
						margin-right: 10px;
					}
				}
			}

			.cat-head, .cat-child li {
				margin-bottom: 10px;
			}

			.cat-head:hover {
				@extend .font-weight-semi-bold;
			}

			.cat-child {
				padding-left: 15px;

				li {
					&.active, &:hover {
						a {
							@extend .primary-color;
							@extend .font-weight-semi-bold;
						}
					}
				}
			}
		}

		&__main {
			width: 75%;

      &__title {
        padding: 0 4%;
      }
		}

		&__sidebar, &__main {
			padding-top: 25px;
			padding-bottom: 25px;
		}

		&__cats {
			height: calc(100vh - 210px);
    	margin-top: 10px;
		}

		&__list {
			padding: 20px 4% 0;

			.item {
        margin-bottom: 30px;

        &__body {
          padding: 10px 0;
        }

        &:hover {
          .item {
            &__head {
              opacity: 0.8;
            }
          }
        }
      }
		}

    &__modal {
      &__upload {
        padding: 60px 15px;

        &__wrap {
          max-width: 320px;
          padding: 30px;
          @extend .color_bg_gray_light;
          @extend .margin-center;
          @extend .text-center;

          input {
            position: absolute;
            top: 0;
            left: 0;
            @extend .full-width;
            opacity: 0;
          }
        }
        &__desc {
          margin-top: 20px;
        }
      }

      &__mylesson {
        &__filter {
          padding: 20px 0 15px;

          .form-item {
            &--class {
              min-width: 150px;
              margin-right: 15px;
            }

            &--subject {
              min-width: 230px;
            }
          }
        }

        &__list {
          padding: 20px 0;
        }
      }
    }
	}
  .modal-info__body__upload {
    padding-top: 0;
  }

	.form-action {
		padding: 25px 0 10px;

		>* {
			&:not(:last-child) {
				margin-right: 15px;
			}
		}
	}

  @media screen and ( min-width: 992px ) and ( max-width: 1199px ) {
    .pre-pare__add {
      &__sidebar {
        width: 30%;
      }
      &__main {
        width: 70%;
      }
    }
  }

  @media screen and ( max-width: 991px ) {
    .pre-pare__add {
      &__main {
        width: 100%;
      }
      &__sidebar {
        position: absolute;
        top: 0;
        bottom: 0;
        z-index: 2;

        &.active {
          transform: translateX(0);
          -webkit-transform: translateX(0);
        }

        &__overlay full-width {
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(255,255,255,.3)
        }
      }
    }
  }
  @media screen and ( min-width: 768px ) and ( max-width: 991px ) {
    .pre-pare__add {
      
      &__sidebar {
        width: 45vw;
        transform: translateX(-45vh);
        -webkit-transform: translateX(-45vh);
      }
    }
  }
  @media screen and ( max-width: 767px ) {
    .pre-pare__add {
      
      &__sidebar {
        width: 85vw;
        transform: translateX(-85vh);
        -webkit-transform: translateX(-85vh);
      }

      &__modal {
        &__mylesson {
          &__filter {
            display: block;

            .form-item {
              &--class, &--subject {
                min-width: 100%;
              }

              &--class {
                margin-right: 0;
              }
            }
          }
        }
      }
    }

    .form-item {
      margin-bottom: 10px;
    }
  }

  @media screen and ( max-width: 767px ) {
    .pre-pare__add {
      &__list, &__main__title, &__head {
        padding-left: 15px;
        padding-right: 15px;
      }
    }
  }
</style>
